export class Arrays {
    static sum(arr: any[], callback: (item: any) => number): number {
        let result = 0;
        arr.forEach(item => result += callback(item));
        return result;
    }
}